import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import DetailLineItems from './DetailLineItems';
import InfoBox from '../../../common/InfoBox';
import Item from '../../../../models/Item';
import { AttachmentType } from '../../../../config/constants';
import AttachmentUploader from '../../../common/AttachmentUploader';
import formPropsType from '../../../common/types/formPropsType';
import AttachmentLineItem from './AttachmentLineItem';
import './Services.css';

class Services extends PureComponent {
  render() {
    const { item, formProps, startInEditMode } = this.props;

    const uploadCallback = (results) => {
      formProps.setFieldValue('attachments', [...item.attachments, ...results]);
      formProps.handleSubmit();
    };

    const onDeleteAttachment = (attachment) => {
      const atts = item.attachments.filter((att) => {
        return att.id !== attachment.id;
      });

      formProps.setFieldValue('attachments', atts);
      formProps.handleSubmit();
    };

    return (
      <div className="servicesGrid">
        <InfoBox title="Insurance" className="insuranceInfoBox">
          <dl>
            <DetailLineItems
              item={item}
              properties={[
                'insurance_contact',
                'insurance_policy_number',
                'insurance_policy_start',
                'insurance_policy_end',
                'insurance_value',
                'insurance_notes',
              ]}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />

            <dt>Attachments:</dt>
            {item.attachments
              .filter(a => a.type === AttachmentType.INSURANCE)
              .map(a => (
                <dd key={a.id}>
                  <AttachmentLineItem
                    attachment={a}
                    formProps={formProps}
                    onDeleteAttachment={onDeleteAttachment}
                  />
                </dd>
              ))}
            <dd>
              <AttachmentUploader
                attType={AttachmentType.INSURANCE}
                onSuccess={uploadCallback}
              />
            </dd>
          </dl>
        </InfoBox>

        <InfoBox title="Appraisals" className="appraisalsInfoBox">
          <dl>
            <DetailLineItems
              item={item}
              properties={[
                'appraisal_contact',
                'appraisal_date',
                'appraisal_value',
                'appraisal_cost',
                'appraisal_notes',
              ]}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />

            <dt>Attachments:</dt>
            {item.attachments
              .filter(a => a.type === AttachmentType.APPRAISAL)
              .map(a => (
                <dd key={a.id}>
                  <AttachmentLineItem
                    attachment={a}
                    formProps={formProps}
                    onDeleteAttachment={onDeleteAttachment}
                  />
                </dd>
              ))}
            <dd>
              <AttachmentUploader
                attType={AttachmentType.APPRAISAL}
                onSuccess={uploadCallback}
              />
            </dd>
          </dl>
        </InfoBox>


        {item.hasGrading() && (
        <InfoBox title="Grading And Authentication" className="gradingInfoBox">
          <dl>
            <DetailLineItems
              item={item}
              properties={[
                'grading_contact',
                'grading_date',
                'grading_cost',
                'grading_grade',
                'grading_notes',
              ]}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />

            <dt>Attachments:</dt>
            {item.attachments
              .filter(a => a.type === AttachmentType.GRADING)
              .map(a => (
                <dd key={a.id}>
                  <AttachmentLineItem
                    attachment={a}
                    formProps={formProps}
                    onDeleteAttachment={onDeleteAttachment}
                  />
                </dd>
              ))}
            <dd>
              <AttachmentUploader
                attType={AttachmentType.GRADING}
                onSuccess={uploadCallback}
              />
            </dd>
          </dl>
        </InfoBox>
        )}

        {item.hasConservation() && (
          <InfoBox title="Conservation" className="conservationInfoBox">
            <dl>
              <DetailLineItems
                item={item}
                properties={item.category === 'ART' ? [
                  'art_conservation_contact',
                  'art_conservation_type',
                  'art_conservation_start_date',
                  'art_conservation_end_date',
                  'art_conservation_cost',
                  'art_conservation_notes',
                ] : [
                  'ant_conservation_contact',
                  'ant_conservation_type',
                  'ant_conservation_start_date',
                  'ant_conservation_end_date',
                  'ant_conservation_cost',
                  'ant_conservation_notes',
                ]}
                formProps={formProps}
                startInEditMode={startInEditMode}
              />

              <dt>Attachments:</dt>
              {item.attachments
                .filter(a => a.type === AttachmentType.CONSERVATION)
                .map(a => (
                  <dd key={a.id}>
                    <AttachmentLineItem
                      attachment={a}
                      formProps={formProps}
                      onDeleteAttachment={onDeleteAttachment}
                    />
                  </dd>
                ))}
              <dd>
                <AttachmentUploader
                  attType={AttachmentType.CONSERVATION}
                  onSuccess={uploadCallback}
                />
              </dd>
            </dl>
          </InfoBox>
        )}
      </div>
    );
  }
}

Services.propTypes = {
  item: PropTypes.instanceOf(Item).isRequired,
  formProps: formPropsType.isRequired,
  startInEditMode: PropTypes.bool,
};

Services.defaultProps = {
  startInEditMode: false,
};

export default Services;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/Services.jsx